import { isSensitiveFieldKind } from '../../../../vendor/agentplace-a2ui/field-sensitivity.ts';
import type { ComposerField, ComposerItemInput } from '../stage/composer-draft.ts';
import type { A2uiSurfaceApi } from './surface-context.ts';

export interface DraftFieldBinding {
  id: string;
  label: string;
  /** Omit for a read-only detail whose displayed value is authoritative. */
  path?: string;
  kind?: string;
  value?: string;
  options?: { value: string; label: string }[];
}

/** Capture only the declared fields after an edit, including clears and not-yet-complete input.
 * Call from a visitor edit, never rendering or an effect: removal must stay removed until another edit.
 * The surface's bindings remain the field owner. This is the removable snapshot sent with free text.
 */
export function stageFieldDraft(
  api: Pick<A2uiSurfaceApi, 'getValue' | 'addToMessage'> | null,
  input: Omit<ComposerItemInput, 'fields'> & { fields: DraftFieldBinding[] },
): void {
  if (!api?.addToMessage) return;
  const fields: ComposerField[] = [];
  for (const field of input.fields) {
    if (isSensitiveFieldKind(field.kind) || !field.id || !field.label) continue;
    const saved = field.path ? api.getValue(field.path) : undefined;
    const value = saved === undefined ? (field.value ?? '') : String(saved ?? '');
    const valueLabel = field.options?.find((option) => option.value === value)?.label;
    fields.push({ id: field.id, label: field.label, value, ...(valueLabel ? { valueLabel } : {}) });
  }
  if (fields.length) api.addToMessage({ ...input, fields });
}
